import { render, staticRenderFns } from "./website-location.vue?vue&type=template&id=1c824e67&scoped=true&"
import script from "./website-location.vue?vue&type=script&lang=js&"
export * from "./website-location.vue?vue&type=script&lang=js&"
import style0 from "./website-location.vue?vue&type=style&index=0&id=1c824e67&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c824e67",
  null
  
)

export default component.exports